<div class="modal-content w-100 h-100 d-flex flex-column">
  <apm-section-title [title]="'448741' | apmTranslate"></apm-section-title>
  <div class="mb-1">{{ 448751 | apmTranslate }}</div>
  <div class="organization-select">
    <apm-select
      [(ngModel)]="selectedOrganization"
      [placeholder]="'444827' | apmTranslate"
      [clearable]="false"
      [items]="(organizations$ | async) || []"
      bindLabel="name"
    >
      <div class="d-flex" *apmSelectLabelTpl="let item; let clear = clear">
        {{ item['customerCode'] ? item['customerCode'] + ' -' : '' }} {{ item['name'] }}
      </div>
      <div class="d-flex" *apmSelectOptionlTpl="let item; let clear = clear">
        <div class="d-flex flex-column ng-value-label text-truncate">
          <span class="fw-bold">{{ item['customerCode'] ? item['customerCode'] + ' -' : '' }} {{ item['name'] }}</span>
        </div>
      </div>
    </apm-select>
  </div>
  <hr class="gray-divider-1 mt-4 mb-4" />
  <div class="d-flex justify-content-end">
    <apm-button class="me-3" variant="secondary" (click)="closeDialog()" additionalClass="min-w-md"
      >{{ '444714' | apmTranslate }}
    </apm-button>
    <apm-button (click)="closeDialog(selectedOrganization)" additionalClass="min-w-md"
      >{{ '445275' | apmTranslate }}
    </apm-button>
  </div>
</div>
